(function () {
  const root = document.querySelector('.ss-site');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ss-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -70px 0px' });

    document.querySelectorAll('.ss-reveal').forEach((el) => observer.observe(el));
  } else {
    document.querySelectorAll('.ss-reveal').forEach((el) => el.classList.add('ss-in'));
  }

  const glow = document.querySelector('.ss-cursor-glow');
  if (glow && !reduceMotion) {
    window.addEventListener('pointermove', (event) => {
      glow.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
    }, { passive: true });
  }
})();
